import { useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/api/apiSlice";
import Todo from "./Todo";

export default function TodoList() {
	const filters = useSelector((state) => state.filters);

	const filterByStatus = (todo) => {
		const { status } = filters;
		switch (status) {
			case "Complete":
				return todo.completed;

			case "Incomplete":
				return !todo.completed;

			default:
				return true;
		}
	};

	const filterByColors = (todo) => {
		const { colors } = filters;
		if (colors.length > 0) {
			return colors.includes(todo?.color);
		}
		return true;
	};

	const {
		data: todos,
		isLoading,
		isSuccess,
	} = useGetTodosQuery(
		{ status: filters?.status, colors: filters?.colors },
		{ refetchOnMountOrArgChange: true }
	);

	if (isLoading) {
		return <div className="">Loading</div>;
	}

	if (isSuccess) {
		return (
			<>
				<div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
					{todos
						.filter(filterByStatus)
						.filter(filterByColors)
						.map((todo) => {
							if (!todo.completed) {
								return <Todo todo={todo} key={todo.id} />;
							} else return null;
						})}
				</div>

				{filters?.status !== "Incomplete" &&
					todos
						.filter(filterByStatus)
						.filter(filterByColors)
						.filter((todo) => todo.completed === true).length > 0 && (
						<div className="mt-6 mb-4 text-xl">All Completed</div>
					)}

				<div className="mt-4 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
					{todos
						.filter(filterByStatus)
						.filter(filterByColors)
						.map((todo) => {
							if (todo.completed) {
								return <Todo todo={todo} key={todo.id} />;
							} else return null;
						})}
				</div>
			</>
		);
	}
}
